"use strict";

var intersect = require('array-intersect')["default"];

module.exports = function () {
  if (this.opts.filterable === true) {
    return this.opts.dateColumns;
  }

  if (this.opts.filterable === false) {
    return [];
  }

  return intersect(this.opts.filterable, this.opts.dateColumns);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/datepicker-columns.js
// module id = 1579
// module chunks = 61